// extracted by mini-css-extract-plugin
export const companyLogoCard = "company-logo-card-module--companyLogoCard--1Ehn2";
export const small = "company-logo-card-module--small--2qbHG";